import { useMsal } from "@azure/msal-react";
import { useAppAuth } from "./appAuthContext";
import GenericPages from "../routes/GenericPages";

const AuthGuard = ({ children }) => {
    const { isLoggedIn } = useAppAuth();
    const { inProgress } = useMsal();

    if (inProgress !== "none") {
        return null; // or spinner
    }

    return isLoggedIn ? children : <GenericPages />;
};


export default AuthGuard;
